import { tokenState } from "./tokenState";
import { httpClient, post } from "../api/http";

export async function login(email: string, password: string) {
  const response = await post(
    "/v1/login/",
    {
      email,
      password,
    },
    true
  );
  tokenState.setTokens(response);
  tokenState.setUsername(email);
}

// TODO: [Critical] Replace hardcoded guest token with backend endpoint (e.g. POST /v1/auth/guest-token/)
// TODO: [Critical] Use JWT role claim (e.g. payload.role === 'guest') instead of matching user_id
const GUEST_TOKEN = {
  refresh:
    "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJ0b2tlbl90eXBlIjoicmVmcmVzaCIsImV4cCI6NDkxMjM5MTg4MiwiaWF0IjoxNzI3MjU1ODgyLCJqdGkiOiI4NzU0YTU4ZjBjYWU0ODBiODVmZGJkNzdkYTU3ZTRiNSIsInVzZXJfaWQiOjJ9.zXLKX2uuXg00G0ffSVfvPE3Euyf76O18jSyk-A2NeBc",
  access:
    "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJ0b2tlbl90eXBlIjoiYWNjZXNzIiwiZXhwIjo0OTEyMzkxODgyLCJpYXQiOjE3MjcyNTU4ODIsImp0aSI6IjgwMzg2YjQzZTdkNDRhMGE5ZjFjOGM2Yzg0YmU3OTYxIiwidXNlcl9pZCI6Mn0.OSHQVcmEOUYCq0vNe1Yma5qY14eKE4FAYX4pW1nExvw",
};
const GUEST_USER_ID = JSON.parse(atob(GUEST_TOKEN.access.split(".")[1])).user_id;

export function guestLogin() {
  if (isLoggedIn() && !isGuest()) return;
  tokenState.setTokens(GUEST_TOKEN);
}

export function isGuest(): boolean {
  const token = tokenState.accessToken.get();
  if (!token) return false;
  try {
    const payload = JSON.parse(atob(token.split(".")[1]));
    return payload.user_id === GUEST_USER_ID;
  } catch {
    return false;
  }
}

export function isLoggedIn(): boolean {
  return !!tokenState.refreshToken.get();
}


export async function signUp(
  username: string,
  password: string,
  confirm_password: string,
  email: string,
  first_name: string,
  last_name: string,
  organization_name: string
) {
  const response = await post(
    "/v1/register/",
    {
      username,
      password,
      confirm_password,
      email,
      first_name,
      last_name,
      organization_name,
    },
    true
  );
}

export const changePassword = async (
  oldPassword: string,
  newPassword: string
) => {
  return httpClient.patch(`/v1/change_password/`, {
    old_password: oldPassword,
    new_password: newPassword,
  });
};

export const setNewForgotPassword = async (token: string, Password: string) => {
  return httpClient.patch(`v1/reset_password/`, {
    token: token,
    password: Password,
  });
};

export async function logout() {
  localStorage.removeItem("isRefreshed");
  localStorage.removeItem("access");
  tokenState.clearTokens();
  window.location.href = "/";
}

export const forgetPassword = async (email: string) => {
  const response = await post("/v1/forgot_password/", { email }, true);
};
